export default __webpack_public_path__ + "media/images/icons/edit-02b718912b86d99c13dc58232c119522.svg";